import { IData } from '@hooks/useData';
import { useMenu } from '@hooks/useMenu';
import { useModalWindow } from '@hooks/useModalWindow';
import ILinha from '@model/Linha';
import { IVendedor } from '@model/Vendedor';
import { IVendedorMovimentacao } from '@model/VendedorMovimentacao';
import { IVendedorMovimentacaoFilter } from '@services/VendedorMovimentacaoService';
import React from 'react';
import { AtribuirModal } from './AtribuirModal';
import { VendedorMovimentacaoFilter } from './Filter';
import { VendedorMovimentacaoMenu } from './Menu';
import { FichaVendedorMovimentacaoTable } from './Table';

export type FichaVendedorMovimentacaoProps = {
    data: IData<IVendedorMovimentacao, IVendedorMovimentacaoFilter>
    dataInventario: IData<ILinha, {}>
    isLoading: boolean
    vendedor: IVendedor
}

export function FichaVendedorMovimentacao ({ data, dataInventario, isLoading, vendedor }: FichaVendedorMovimentacaoProps) {
    const menu = useMenu();
    const atribuirModal = useModalWindow();

    return (
        <React.Fragment>
            <VendedorMovimentacaoFilter 
                filter={data.filter}
                isLoading={isLoading}
                atribuirModal={atribuirModal}
            />

            <FichaVendedorMovimentacaoTable 
                isLoading={isLoading}
                data={data}
                vendedor={vendedor}
                menu={menu}
            />

            <AtribuirModal 
                modal={atribuirModal}
                onAtribuicaoRegistrada={() => {
                    data.filter.handleFilterRequest();
                    dataInventario.filter.handleFilterRequest();
                }}
                vendedor={vendedor}
            />

            {
                data.focusedRow !== undefined && (
                    <React.Fragment>
                        <VendedorMovimentacaoMenu 
                            menu={menu}
                            vendedorMovimentacao={data.focusedRow}
                        />
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}